const {
  REACT_APP_GOOGLE_CLIENT_ID,
  REACT_APP_LINKEDIN_CLIENT_ID,
  REACT_APP_LINKEDIN_LOGIN_REDIRECT_URI,
  REACT_APP_LINKEDIN_REGISTER_REDIRECT_URI,
  REACT_APP_STRIPE_PKEY,
  REACT_APP_CRONOFY_CLIENT_ID,
  REACT_APP_CRONOFY_REDIRECT_URI
} = process.env;
export const googleClientId = REACT_APP_GOOGLE_CLIENT_ID;
export const linkedinClientId = REACT_APP_LINKEDIN_CLIENT_ID;
export const linkedinLoginRedirectUri = REACT_APP_LINKEDIN_LOGIN_REDIRECT_URI;
export const linkedinRegisterRedirectUri = REACT_APP_LINKEDIN_REGISTER_REDIRECT_URI;
export const stripePKey = REACT_APP_STRIPE_PKEY;
export const cronofyClientId = REACT_APP_CRONOFY_CLIENT_ID;
export const cronofyRedirectUri = REACT_APP_CRONOFY_REDIRECT_URI;
export const brands = {
  getwiseconnect: {
    styles: {
      "@primary-color": "#0067A8"
    },
    title: "getWise",
    contactEmail: "info@getwiseconnect.com",
    logoUrl: "https://211381615390-wiseher-media-prod-us-east-1.s3.amazonaws.com/brand-assets/logos/getWise.png",
    faviconUrl: "https://211381615390-wiseher-media-prod-us-east-1.s3.amazonaws.com/brand-assets/favicons/getWise.ico",
    landingUrl: "https://www.getwiseconnect.com",
    headerLinks: [
      {
        name: "Experts",
        to: "/experts",
        activeClassName: "header-active",
        cbName: "goToExpertsAction"
      },
      {
        name: "How It Works",
        to: "https://www.getwiseconnect.com/how-it-works/",
        target: "_blank"
      },
      {
        name: "About Us",
        to: "https://www.getwiseconnect.com/about-us/",
        target: "_blank"
      }
    ],
    footerLinks: {
      column1: [
        {
          name: "Home",
          to: "/"
        },
        {
          name: "Find an Expert",
          to: "/experts"
        },
        {
          name: "Perks",
          to: "/perks"
        }
      ],
      column2: [
        {
          name: "Contact Us",
          cbName: "handleContactUs"
        },
        {
          name: "About Us",
          to: "https://www.getwiseconnect.com/about-us/",
          target: "_blank"
        }
      ],
      column3: [
        {
          name: "Privacy Policy",
          to: "https://www.getwiseconnect.com/privacy",
          target: "_blank"
        },
        {
          name: "Terms of Use",
          to: "https://getwiseconnect.com/terms-and-conditions-terms-of-use/",
          target: "_blank"
        }
      ]
    },
    contentLinks: {
      outlookExchange: {
        name: "https://www.getwiseconnect.com/365-exchange-calendarsetup",
        to: "https://www.getwiseconnect.com/365-exchange-calendarsetup",
        target: "_blank"
      }
    }
  },
  wiseher: {
    styles: {
      "@primary-color": "#0067A8"
    },
    title: "wiseHer",
    contactEmail: "info@wiseher.com",
    logoUrl: "https://211381615390-wiseher-media-prod-us-east-1.s3.amazonaws.com/brand-assets/logos/wiseHer.png",
    faviconUrl: "https://211381615390-wiseher-media-prod-us-east-1.s3.amazonaws.com/brand-assets/favicons/wiseHer.ico",
    landingUrl: "https://www.wiseher.com",
    headerLinks: [
      {
        name: "Experts",
        to: "/experts",
        activeClassName: "header-active",
        cbName: "goToExpertsAction"
      },
      {
        name: "How It Works",
        to: "https://www.wiseher.com/how-it-works/",
        target: "_blank"
      },
      {
        name: "About Us",
        to: "https://www.wiseher.com/about-our-team/",
        target: "_blank"
      }
    ],
    footerLinks: {
      column1: [
        {
          name: "Home",
          to: "/"
        },
        {
          name: "Find an Expert",
          to: "/experts"
        },
        {
          name: "Perks",
          to: "/perks"
        }
      ],
      column2: [
        {
          name: "Contact Us",
          cbName: "handleContactUs"
        },
        {
          name: "About Us",
          to: "https://www.wiseher.com/about-our-team/",
          target: "_blank"
        }
      ],
      column3: [
        {
          name: "Privacy Policy",
          to: "https://www.wiseher.com/privacy",
          target: "_blank"
        },
        {
          name: "Terms of Use",
          to: "https://getwiseconnect.com/terms-and-conditions-terms-of-use/",
          target: "_blank"
        }
      ]
    },
    contentLinks: {
      outlookExchange: {
        name: "https://www.getwiseconnect.com/365-exchange-calendarsetup",
        to: "https://www.getwiseconnect.com/365-exchange-calendarsetup",
        target: "_blank"
      }
    }
  },
  channelwise: {
    styles: {
      "@primary-color": "#0067A8"
    },
    title: "channelWise",
    contactEmail: "info@channelwise.com",
    logoUrl: "https://211381615390-wiseher-media-prod-us-east-1.s3.amazonaws.com/brand-assets/logos/channelWise.png",
    faviconUrl: "https://211381615390-wiseher-media-prod-us-east-1.s3.amazonaws.com/brand-assets/favicons/channelWise.ico",
    landingUrl: "https://channelwise.com/",
    headerLinks: [
      {
        name: "Experts",
        to: "/experts",
        activeClassName: "header-active",
        cbName: "goToExpertsAction"
      },
      {
        name: "About Us",
        to: "https://www.channelwise.com/about/",
        target: "_blank"
      }
    ],
    footerLinks: {
      column1: [
        {
          name: "Home",
          to: "/"
        },
        {
          name: "Find an Expert",
          to: "/experts"
        },
        {
          name: "Perks",
          to: "/perks"
        }
      ],
      column2: [
        {
          name: "Contact Us",
          cbName: "handleContactUs"
        },
        {
          name: "About Us",
          to: "https://www.channelwise.com/about/",
          target: "_blank"
        }
      ],
      column3: [
        {
          name: "Privacy Policy",
          to: "https://www.channelwise.com/privacy-policy/",
          target: "_blank"
        },
        {
          name: "Terms of Use",
          to: "https://www.channelwise.com/terms-of-use/",
          target: "_blank"
        }
      ]
    },
    contentLinks: {
      outlookExchange: {
        name: "https://www.channelwise.com/365-exchange-calendarsetup",
        to: "https://www.channelwise.com/365-exchange-calendarsetup",
        target: "_blank"
      }
    },
    showCallPrice: true,
    creditBased: true,
    creditAmount: 2500
  },
  localhost: {
    styles: {
      "@primary-color": "#0067A8"
    },
    title: "localhost",
    contactEmail: "info@wiseher.com",
    logoUrl: "https://www.local-host.no/wp-content/uploads/2020/04/logo-localhost-sec-box.png",
    faviconUrl: "https://www.local-host.no/wp-content/uploads/2020/04/logo-localhost-sec-box.png",
    landingUrl: "/",
    headerLinks: [
      {
        name: "Experts",
        to: "/experts",
        activeClassName: "header-active",
        cbName: "goToExpertsAction"
      },
      {
        name: "About Us",
        to: "https://www.getwiseconnect.com/about-our-team/",
        target: "_blank"
      }
    ],
    footerLinks: {
      column1: [
        {
          name: "Home",
          to: "/"
        },
        {
          name: "Find an Expert",
          to: "/experts"
        },
        {
          name: "Perks",
          to: "/perks"
        }
      ],
      column2: [
        {
          name: "Contact Us",
          cbName: "handleContactUs"
        },
        {
          name: "About Us",
          to: "https://www.getwiseconnect.com/about-our-team/",
          target: "_blank"
        }
      ],
      column3: [
        {
          name: "Privacy Policy",
          to: "https://www.getwiseconnect.com/privacy",
          target: "_blank"
        },
        {
          name: "Terms of Use",
          to: "https://getwiseconnect.com/terms-and-conditions-terms-of-use/",
          target: "_blank"
        }
      ]
    },
    contentLinks: {
      outlookExchange: {
        name: "https://www.getwiseconnect.com/365-exchange-calendarsetup",
        to: "https://www.getwiseconnect.com/365-exchange-calendarsetup",
        target: "_blank"
      }
    }
  }
};
const host = window.location.hostname.replace("app.", "").replace("dev.", "").split(".")[0];
export const currentBrand = brands.hasOwnProperty(host) ? brands[host] : brands.getwiseconnect;
